import { lazy } from 'react';

export const ActivePlanList = lazy(() => import('./active_plan/ActivePlanList'));
export const FuturePlanList = lazy(() => import('./future_plan/FuturePlanList'));
export const PlanHistoryList = lazy(() => import('./plan_history/PlanHistoryList'));
